import { observer } from 'mobx-react-lite'
import { useMemo } from 'react'
import { Button, Typography } from 'shared/ui'
import { type RowInbox } from 'entities/Inbox/model/Table/RowInbox'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { useMemberContext } from 'pages/settings/pages/members/context/memberContext'
import { useMembersContext } from 'pages/settings/pages/members/context/membersContext'
import { MemberInboxesTable } from './MemberInboxesTable/MemberInboxesTable'
import { getMemberInboxesColumns } from './MemberInboxesTable/columns'
import { getMemberInboxActions } from './actions/getMemberInboxActions'

import styles from './styles.module.scss'

export const MemberInboxes = observer(() => {
  const { manageInboxWrapper } = useMembersContext()
  const {
    member,
    memberInboxesStore: {
      search,
      setSearch,
      tableStore,
      inboxesRows,
      isAssignInboxButtonShown,
      assignInboxModal,
    },
    loading,
  } = useMemberContext()
  const entities = useEntitiesContext()

  const columns = useMemo(() => {
    if (!member) return []
    return getMemberInboxesColumns(member.id)
  }, [member?.id])

  if (!member) return null

  const rows = inboxesRows.map((item) => {
    item.setActionsProps({
      actions: getMemberInboxActions(member, item, entities),
    })

    return item
  })

  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        <Typography ariaLabel={'inboxes'} variant={'heading-sm'}>
          Inboxes
        </Typography>
        {isAssignInboxButtonShown && (
          <Button
            text={'Assign inbox'}
            iconProps={{ icon: 'add' }}
            contained={'primary'}
            size={'medium'}
            onClick={() => {
              manageInboxWrapper(() => assignInboxModal(member))
            }}
          />
        )}
      </div>
      <MemberInboxesTable<RowInbox>
        setSearch={setSearch}
        search={search}
        tableProps={{
          hidePagination: true,
          ariaLabel: 'MemberInboxesTable',
          rows,
          columns,
          loading,
          store: tableStore,
        }}
      />
    </div>
  )
})
